import crypto from 'crypto';

export const hashData = (data: string): string =>
  crypto.createHash('sha256').update(data, 'utf8').digest('hex').toString();
